jQuery(document).ready(function ($) {

  $('#form-mobile-first-step-button').on('click', function(){
    if($('#form-intersitial').find('input[name="offers"]:checked').length > 0){
      $(".intersitial-form").css("display","grid");
      $(".intersitial-content form").css("overflow","unset")
      $('.intersitial-offers').css("display", "none");
      $('#form-mobile-first-step-button').css("display", "none");
      $('.content-section-header').css("display", "none")
    } else {
      $('.content-section-header').text('Selecione uma oferta para continuar');
      $('.content-section-header').css("color", "darkred");
    }
  });
});

